import React from 'react';

/**
 * Componente: Portada de Día de Picnic (Pantalla Gigante)
 * Se muestra cuando el Admin prepara el juego.
 */
const FrontPage = ({ isActiveWomensMode }) => {
    return (
        <>
            {/* FONDO ESTANDARIZADO DE TU APP */}
            <div className='FrontPage--Riddle__Screen__Background'>
                {/* {isActiveWomensMode ? (
                    <img src='/img/selfiefan/Fondo-SelfieFan-Femenil.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                ) : (
                    <img src='/img/page/backgrounds/background.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
                )} */}
                <img src='/img/games/picnic/lucho-y-tunita-picnic.png' className='FrontPage--Riddle__Screen__Background__Image' alt="Fondo" />
            </div>

            {/* CONTENEDOR CENTRAL */}
            <div className="FrontPageNoisemeter__Screen__Container d-flex flex-column justify-content-center align-items-center" style={{ zIndex: 10, width: '100%', top: '110px' }}>
                {/* Opcional: Una imagen bonita de la canasta o una mosca para decorar la portada */}
                {/* <img 
                    src='/img/picnic/canasta.png' // Asegúrate de tener esta imagen
                    alt="Canasta de Picnic" 
                    className="mb-4 drop-shadow" 
                    style={{ maxWidth: '800px', filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.5))' }} 
                /> */}
                <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />
                <h1 style={{ 
                    fontFamily: '"GFS Didot", serif', 
                    fontSize: '5em', //'8rem', 
                    color: '#000', 
                    fontWeight: 'bold', 
                    //textShadow: '4px 4px 0px rgba(0,0,0,0.3)',
                    textAlign: 'center',
                    lineHeight: '1.2'
                }}>
                    PICNIC
                </h1>
                
                {/* <p className="text-white mt-4" style={{ fontSize: '3rem', fontWeight: 'bold', backgroundColor: 'rgba(0,0,0,0.5)', padding: '10px 40px', borderRadius: '50px' }}>
                    1 VS 1
                </p> */}
                {/* <p className="text-warning mt-2" style={{ fontSize: '2rem', fontWeight: 'bold' }}>
                    ¡Atrapa la comida y aplasta a las moscas!
                </p> */}
            </div>

            {/* FOOTER ESTANDARIZADO */}
            <footer className='SelfieFan__Screen__QR__Footer FooterCredits'>
                Hecho con ♥ por Interaktia | 2026
            </footer>
        </>
    );
};

export { FrontPage };